import { useDispatch } from 'react-redux';
import useGetVehicle from '../hooks/useGetVehicle';
import { setFinancingAvailable } from '../reducers/vehicle';
import FinancingWebComponent from './FinancingWebComponent';

export default function VehicleFinancing() {
  const { vehicle } = useGetVehicle();
  const dispatch = useDispatch();

  const config = vehicle.seller.financingComponent;
  if (!config) {
    return null;
  }

  function onCompanyFetched(company) {
    dispatch(setFinancingAvailable(company.available));
  }

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <FinancingWebComponent
      full-width
      config={config}
      vehicle-price={`${vehicle.price}`}
      vehicle={JSON.stringify({
        Marca: vehicle.brand,
        Modelo: vehicle.model,
        Version: vehicle.version,
        Año: vehicle.year,
      })}
      contact-md-cols="1"
      contact-lg-cols="1"
      contact-xl-cols="1"
      contact-xxl-cols="1"
      terms-cols="2"
      terms-sm-cols="2"
      terms-md-cols="2"
      terms-lg-cols="2"
      terms-xl-cols="2"
      terms-xxl-cols="2"
      no-card="true"
      onCompanyFetched={onCompanyFetched}
    />
  );
}
